/**
 * English translations
 */

const en = {
    // Calendar related
    calendar: {
        today: 'Today',
        month: 'M.',
        week: 'W.',
        day: 'D.',
        expandEarlyHours: 'Expand 0-8h',
        collapseEarlyHours: 'Collapse 0-8h',
        normalMode: 'NORMAL',
        addMode: 'ADD',
        offdayMode: 'OFF',
        adminMode: 'Admin',
        limitSettings: 'Limits',
        helpTitle: 'Mode Description',
        helpNormal: 'NORMAL: Basic mode to check and manage reservations.',
        helpAdd: 'ADD: Mode to create new reservations.',
        helpOff: 'OFF: Mode to set days off.',
        blockedDay: 'Event addition blocked day.',
        studioUnavailable: 'Studio unavailable on this day.',
        overlappingLimit: 'There are already {limit} events. Maximum {limit} allowed.',
        concurrentLimitExceeded: 'Concurrent event limit exceeded: Default limit ({limit}) - Global default setting',
        modal: {
            restrictedAddTitle: 'Add blocked period',
            restrictedEditTitle: 'Edit blocked period',
            eventAddTitle: 'Add event',
            eventEditTitle: 'Edit event',
            reason: 'Reason',
            title: 'Title',
            startDate: 'Start date',
            endDate: 'End date',
            startTime: 'Start time',
            endTime: 'End time',
            allDay: 'All day',
            fullDayRestriction: 'Blocked all day',
            timedRestriction: 'Blocked time range',
            saving: 'Saving...',
            saveChanges: 'Save changes',
            addRestriction: 'Add blocked period',
            addEvent: 'Add event',
            reasonRequired: 'Enter a reason.',
            titleRequired: 'Enter a title.',
            startRequired: 'Select a start time.',
            endRequired: 'Select an end time.',
            endAfterStart: 'The end must be after the start.',
        },
    },

    // Reservation related
    reservation: {
        pageTitle: 'Reservations',
        status: 'Status',
        type: 'What',
        client: 'Client',
        date: 'Date',
        updated: 'Updated',
        created: 'Created',
        memo: 'Memo',
        reservationDate: 'Reservation Date',
        instagram: 'Instagram',
        customerName: 'Customer Name',
        deposit: 'Deposit',
        finalPrice: 'Final Price',
        reservationType: 'Reservation Type',
        email: 'Email',
        phone: 'Phone',
        minPrice: 'Min Price',
        maxPrice: 'Max Price',
        budget: 'Budget',
        description: 'Description',
        preferredPart: 'Preferred Part',
        preferredDates: 'Preferred Dates',
        referenceImages: 'Reference Images',
        flashImage: 'Image',
        category: 'Category',
        artist: 'Artist',

        // Status labels
        statusLabels: {
            requested: 'Requested',
            in_progress: 'In Progress',
            pending: 'Pending',
            confirmed: 'Confirmed',
            deposit_paid: 'Deposit Paid',
            deposit_confirmed: 'Deposit Confirmed',
            completed: 'Completed',
            cancelled: 'Cancelled',
        },
    },

    // Common
    common: {
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        close: 'Close',
        confirm: 'Confirm',
        edit: 'Edit',
        add: 'Add',
        search: 'Search',
        filter: 'Filter',
        yes: 'Yes',
        no: 'No',
        noData: 'No data',
        enterMemo: 'Enter memo...',
    },

    // Error messages
    error: {
        eventUpdateError: 'Error updating event.',
        startEndTimeRequired: 'Start and end times are required.',
        endTimeAfterStart: 'End time must be after start time.',
        userInfoError: 'Cannot load user info. Please refresh the page.',
        dayOffDeleteError: 'Failed to delete DayOff.',
        dayOffAddError: 'Failed to add DayOff.',
        blockDeleteError: 'Failed to delete blocked period.',
        blockAddError: 'Failed to add blocked period.',
        unknownError: 'An unknown error occurred.',
        depositConfirmFailed: 'Deposit confirmation failed: ',
        depositCancelFailed: 'Deposit cancellation failed: ',
        depositProcessError: 'An error occurred during deposit processing: ',
        deleteConfirm: 'Are you sure you want to delete?',
        deleteSuccess: 'Deleted successfully',
    },

    // Success messages
    success: {
        eventUpdatedSuccess: 'Event updated successfully.',
        blockRemoved: 'Blocked period removed.',
        blockAdded: 'Blocked period added.',
    },

    // Message/DM related
    message: {
        noPermission: 'No permission - not your event.',
        updatingEvent: 'Updating...',
        noConnectedEvent: 'No Connected Event',
    },

    // Weather widget
    weather: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    },

    // Reservation summary
    summary: {
        thisMonth: 'This month',
        thisWeek: 'This week',
        today: 'Today',
        count: '',
        next: 'Next',
        pendingDeposit: 'Pending deposit',
        noName: 'No name',
    },

    // Main-page announcement
    announcement: {
        title: 'Announcement',
        write: 'Write announcement',
        edit: 'Edit',
        clear: 'Unpublish',
        clearing: 'Unpublishing...',
        contentLabel: 'Announcement content',
        empty: 'There is no published announcement.',
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
        clearConfirm: 'Unpublish the current announcement?',
        contentRequired: 'Enter the announcement content.',
        contentTooLong: 'Keep the announcement within {max} characters.',
        loadError: 'Could not load the announcement.',
        saveError: 'Could not save the announcement.',
        clearError: 'Could not unpublish the announcement.',
    },

    // Flashbook
    flashbook: {
        title: 'FLASH BOOK',
        newPlanche: '+ NEW',
        empty: 'No planches yet',
        emptyHint: 'Create your first flash sheet',
        createError: 'Create failed',
        available: 'Avail',
        sold: 'Sold',
        replaceImage: 'Replace',
        download: 'DL',
        downloadAll: 'Download all flashes',
        downloadAllError: 'Failed to download all flashes.',
        crop: 'Crop',
        flashName: 'Name',
        size: 'Size',
        showInfo: 'Info',
        visible: 'ON',
        hidden: 'OFF',
        downloadOriginal: 'Original',
        downloadCanvas: 'Canvas',
        deleteFailed: 'Delete failed',
        deleteConfirm: 'Delete {number}?',
        nameSaved: 'Name saved',
        sizeSaved: 'Size saved',
        soldStyle: 'SOLD',
        titleStyle: 'TITLE',
        bgStyle: 'BG',
    },

    // Stock Management
    stock: {
        title: 'STOCK',
        add: 'ADD',
        save: 'SAVE',
        cancel: 'CANCEL',
        delete: 'DELETE',
        name: 'Item Name',
        quantity: 'Qty',
        category: 'Category',
        image: 'Image URL',
        supplier: 'Supplier',
        priceHT: 'Price HT',
        tvaRate: 'TVA %',
        minStock: 'Min Stock',
        noData: 'No items',
        noAccess: 'No access',
        lowStock: 'LOW',
        all: 'All',
        uncategorized: 'Uncategorized',
        searchPlaceholder: 'Search...',
        confirmDelete: 'Delete this item?',
        addItem: 'ADD ITEM',
        editItem: 'EDIT ITEM',
        loadError: 'Load failed',
        saveError: 'Save failed',
        deleteError: 'Delete failed',
        categories: 'Categories',
        newCategory: 'New category...',
    },
};

export default en;
